import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { getClassNameFactory } from "@dcl/ui";
import { SHOW_LESS, SHOW_MORE } from "./constants";

var truncateText = function truncateText(text, maxLength, suffix) {
  if (text.length <= (maxLength !== null && maxLength !== void 0 ? maxLength : 0)) {
    return text;
  }

  if (text.charAt((maxLength !== null && maxLength !== void 0 ? maxLength : 0) - 1) === " ") {
    return text.substring(0, (maxLength !== null && maxLength !== void 0 ? maxLength : 0) - 1) + suffix;
  }

  var lastSpaceIndex = text.lastIndexOf(" ", maxLength !== null && maxLength !== void 0 ? maxLength : 0);

  if (lastSpaceIndex !== -1 && lastSpaceIndex >= (maxLength !== null && maxLength !== void 0 ? maxLength : 0)) {
    return text.substring(0, lastSpaceIndex) + suffix;
  }

  var nextSpaceIndex = text.indexOf(" ", maxLength !== null && maxLength !== void 0 ? maxLength : 0);

  if (nextSpaceIndex !== -1 && nextSpaceIndex > (maxLength !== null && maxLength !== void 0 ? maxLength : 0) + 1) {
    return text.substring(0, nextSpaceIndex) + suffix;
  }

  if (lastSpaceIndex !== -1 && lastSpaceIndex < (maxLength !== null && maxLength !== void 0 ? maxLength : 0)) {
    var wordEndIndex = text.indexOf(" ", lastSpaceIndex + 1);

    if (wordEndIndex !== -1 && wordEndIndex > (maxLength !== null && maxLength !== void 0 ? maxLength : 0)) {
      return text.substring(0, wordEndIndex) + suffix;
    }

    return text;
  }

  return text;
};

var ShowMore = function ShowMore(_ref) {
  var _ref$enableShowMore = _ref.enableShowMore,
      enableShowMore = _ref$enableShowMore === void 0 ? false : _ref$enableShowMore,
      maxTextLength = _ref.maxTextLength,
      cell = _ref.cell;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showMore = _React$useState2[0],
      setShowMore = _React$useState2[1];

  var getClassName = getClassNameFactory(ShowMore.displayName);

  var checkIfStringAndLongText = function checkIfStringAndLongText(value, max) {
    return typeof value === "string" && value.length > max && enableShowMore;
  };

  var truncatedContent = enableShowMore ? truncateText(cell === null || cell === void 0 ? void 0 : cell.value, showMore ? Infinity : maxTextLength, "...") : cell === null || cell === void 0 ? void 0 : cell.value;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "showMore"
    })
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "truncatedTextMargin"
    })
  }, truncatedContent), checkIfStringAndLongText(cell === null || cell === void 0 ? void 0 : cell.value, maxTextLength !== null && maxTextLength !== void 0 ? maxTextLength : 0) && /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "showMoreButton"
    }),
    onClick: function onClick() {
      return setShowMore(!showMore);
    }
  }, showMore ? SHOW_LESS : truncatedContent !== (cell === null || cell === void 0 ? void 0 : cell.value) && SHOW_MORE)));
};

ShowMore.displayName = "ShowMore";
export default ShowMore;